import React from 'react';

import SightIcon from '../../icons/SightIcon';
import MapPointIcon from '@ott/map-point-icon';
import EarthIcon from '@ott/icon-earth';
import styles from './CustomOptionRenderer.scss';

function GeoOptionIcon({ option }) {
  if (!option) {
    return null;
  }

  if (option.type === 'sight') {
    return <SightIcon />;
  }

  if (option.type === 'city') {
    return <MapPointIcon />;
  }

  return <EarthIcon />;
}

export default function CustomOptionRenderer(option) {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <GeoOptionIcon option={option} />
      </div>
      <div className={styles.text}>
        <span className={styles.name}>{option.name}</span>
        <div className={styles.description}>{option.description}</div>
      </div>
    </div>
  );
}
